import React, { Component } from 'react';
import TextField from '../base/TextField';

class FullPhone extends Component {
  render() {
    return (
      <div className="form-fullphone-row">
        <label className="form-label">
          Main Phone <span className="form-required" title="This field is required."></span> <span className="usa-hint">XXXXXXX</span>
        </label>
        <div className='phone-fields'>
          <TextField name="info_phone_area"
            className={['form-item-phone-area']}
            placeholder="Area Code" />
          <TextField name="info_phone_number"
            className={['form-item-phone-number']}
            placeholder="Phone Number" />
          <TextField name="info_phone_ext"
            className={['form-item-phone-ext']}
            placeholder="ext." />
        </div>
      </div>
    );
  }
}

export default FullPhone;
